import React from 'react';
import { connect } from 'react-redux';
import {
  Button,
  Col,
  DatePicker,
  Drawer,
  Form,
  Input,
  Row,
  Select,
  Upload,
  message,
  Checkbox
} from 'antd';
// import DocViewer, { JPGRenderer, MSDocRenderer, PDFRenderer, PNGRenderer, TXTRenderer } from "react-doc-viewer";
import { InboxOutlined } from '@ant-design/icons';
import reqwest from 'reqwest';

const { Dragger } = Upload;

const mapStateToProps = state => ({
});

const mapDispatchToProps = dispatch => ({
});



const FormBuilder = ({ type, value, propsUploadFiles, handleChange, disabledCheckbox }) => {
  var formData = {
    data_search_import: [
      {
        formType: "checkbox",
        name: "autoClassification",
        label: "Auto Classification",
        rules: [{ required: true, message: '' }],
        placeholder: ""
      },
      {
        formType: "fileDragger",
        name: "",
        label: "",
        rules: [{ required: true, message: '' }],
        placeholder: ""
      }
    ]
  };


  const getField = (formType, placeholder, value, handleChange, mode, options) => {
    // mode -> single/multiple
    switch (formType) {
      case 'checkbox':
        return <Checkbox></Checkbox>;
        break;
      case 'fileDragger':
        return <Dragger {...propsUploadFiles}>
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p className="ant-upload-text">Click or drag file to this area to upload</p>
          <p className="ant-upload-hint">
            Support for a single or bulk upload. Strictly prohibit from uploading company data or other
            band files
          </p>
        </Dragger>;
        break;
      default:
        break;
    }
  };

  return (
    <Form layout="vertical" hideRequiredMark>
      <Row gutter={0}>
        {
          (formData[type] || []).map(({ formType, name, label, rules, placeholder, mode, options }) => {
            if (formType === 'checkbox') {
              return (
                <Col span={24}>
                  <Form.Item name={name}  >
                    <Checkbox onClick={handleChange} disabled={disabledCheckbox}>{label}</Checkbox>
                  </Form.Item>
                </Col>
              )
            } else {
              return (
                <Col span={24}>
                  <Form.Item name={name} label={label} rules={rules}>
                    {
                      getField(formType, placeholder, null, handleChange, mode, options)
                    }
                  </Form.Item>
                </Col>
              );
            }
          })
        }
      </Row>
    </Form>
  );
}

class FormDrawer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      btnSize: "small",
      fileList: [],
      uploading: false,
      fileUploaded: false
    };
  }

  componentWillMount() { }
  componentWillUnmount() { }
  componentDidUpdate() { }



  render() {
    var { config, title, btnSubmitLabel, onDrawerClose, isDrawerVisible, formType, value, handleChange } = this.props;
    const { uploading, fileList, fileUploaded } = this.state;

    const handleUpload = () => {
      const { fileList } = this.state;
      const formData = new FormData();
      fileList.forEach(file => {
        formData.append('files[]', file);
      });
      this.setState({
        uploading: true
      });

      this.props.handleStateUpdate('disabledCheckbox', true)
      // You can use any AJAX library you like
      reqwest({
        url: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
        method: 'post',
        processData: true,
        data: formData,
        success: () => {
          this.setState({
            fileList: [],
            uploading: false,
            fileUploaded: true
          });
          var date = new Date();
          var classifyAutoChecked = this.props.handleStateUpdate('classifyAutoChecked');
          var tableClassifyData = fileList.map(({ name, type }, i) => {
            return {
              key: (i + 1),
              hash: (i + 1),
              documentName: name,
              type: classifyAutoChecked ? (name.indexOf('Sport') >= 0 ? 'Sport' : (name.indexOf('Tech') >= 0 ? 'Tech' : (name.indexOf('Entertainment') >= 0 ? 'Entertainment' : 'Other'))) : '',
              updoadDate: `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`
            }
          });

          // console.log('tableClassifyData', tableClassifyData)

          setTimeout(() => {
            this.props.handleStateUpdate('classifyBtnClick', false);
            this.props.handleStateUpdate('loading', false);
            this.props.handleStateUpdate('fileUploaded', true);
            this.props.handleStateUpdate('data', tableClassifyData);
            message.success('upload successfully.');
            onDrawerClose()
          }, 1000);
        },
        error: () => {
          this.setState({
            uploading: false,
            fileUploaded: false
          });
          this.props.handleStateUpdate('fileUploaded', false);
          message.error('upload failed.');
        }
      });
    };

    const propsUploadFiles = {
      multiple: true,
      onRemove: file => {
        this.setState(state => {
          const index = state.fileList.indexOf(file);
          const newFileList = state.fileList.slice();
          newFileList.splice(index, 1);
          return {
            fileList: newFileList,
          };
        });
      },
      beforeUpload: file => {
        // transformFile: (file) => {
        this.setState(state => ({
          fileList: [...state.fileList, file],
        }));
        return false;
      },
      fileList,
    };


    return (
      <Drawer
        title={title}
        placement={config ? config.placement : "right"}
        width={config ? '100vw' : 400}
        height={'100vh'}
        onClose={onDrawerClose}
        visible={isDrawerVisible}
        bodyStyle={config ? config.bodyStyle : { paddingBottom: 80 }}

        footer={
          <div style={{ textAlign: 'right' }}>
            <Button onClick={onDrawerClose} style={{ marginRight: 8 }} size={this.state.btnSize}>
              Cancel
            </Button>
            {
              formType === 'data_search_import' ? <Button type="primary" size={this.state.btnSize}
                onClick={handleUpload}
                disabled={fileList.length === 0}>
                {uploading ? 'Uploading...' : 'Start Upload'} </Button> :
                <Button type="primary" size={this.state.btnSize}>
                  {btnSubmitLabel}
                </Button>
            }
          </div>
        } >
        <FormBuilder
          type={formType}
          value={value}
          propsUploadFiles={propsUploadFiles}
          handleChange={handleChange}
          disabledCheckbox={this.props.disabledCheckbox} />
      </Drawer>
    );
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(FormDrawer);


// WEBPACK FOOTER //
// src/components/FormDrawer/FormDrawer.js